import React, { forwardRef, useImperativeHandle } from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { useErrorInputs } from '../../hooks/useErrorInputs';
import { useTranslation } from 'react-i18next';

export const EconomicActivityForm = forwardRef(({ dto, handleInputChange }, ref) => {
    const { t } = useTranslation();
    const [errorInputs, handleErrorInput] = useErrorInputs({});

    const validateField = (name, value) => {
        if (!value || value.trim() === '') {
            handleErrorInput(name, { isError: true, messageError: 'Campo requerido' });
            return false;
        } else {
            handleErrorInput(name, { isError: false, messageError: '' });
            return true;
        }
    };

    useImperativeHandle(ref, () => ({
        validateForm,
    }));

    const requiredField = ['type_ciiu', 'code_ciiu', 'description_ciiu'];
    const validateForm = () => {
        let hasError = false;

        requiredField.forEach((field) => {
            const isValid = validateField(field, dto[field]);
            if (!isValid) hasError = true;
        });

        return !hasError;
    };

    return (
        <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={{ xs: 12}}>
                <Typography variant="h6">{t("suppliers.economicActivityTitle")}</Typography>
            </Grid>

            <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                    fullWidth
                    size="small"
                    label={t('commonFields.name')}
                    name='type_ciiu'
                    value={dto.type_ciiu}
                    onChange={handleInputChange}
                    error={!!errorInputs.type_ciiu?.isError}
                    helperText={errorInputs.type_ciiu?.messageError}
                    required
                />
            </Grid>

            <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                    fullWidth
                    size="small"
                    label={t('commonFields.economicActivity.code')}
                    name='code_ciiu'
                    value={dto.code_ciiu || ''}
                    onChange={handleInputChange}
                    error={!!errorInputs.code_ciiu?.isError}
                    helperText={errorInputs.code_ciiu?.messageError}
                    required
                />
            </Grid>

            <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                    fullWidth
                    size="small"
                    name='description_ciiu'
                    label={t('commonFields.economicActivity.description')}
                    value={dto.description_ciiu}
                    onChange={handleInputChange}
                    error={!!errorInputs.description_ciiu?.isError}
                    helperText={errorInputs.description_ciiu?.messageError}
                    required
                />
            </Grid>
        </Grid>
    );
});
